import TagManager from "react-gtm-module";
import { eraseCookies, getCookie } from "vanilla-cookieconsent";

const CONSENT_STORAGE_STATE = {
  DENIED: "denied",
  GRANTED: "granted",
};

const COOKIE_CONSENT_CATEGORY = {
  ADS: "ad_storage",
  ANALYTICS: "analytics_storage",
  PERSONALIZATION: "ad_personalization",
  USER_DATA: "ad_user_data",
};

const removeAdCookies = () => {
  const adCookieNames = ["_ga", "_gid"];

  try {
    eraseCookies(adCookieNames);
  } catch (e) {
    console.error("Error while removing ad cookies", e);
  }
};

const removeAnalyticsCookies = () => {
  const analyticsCookieNames = ["_ga", "_gid"];

  try {
    eraseCookies(analyticsCookieNames);
  } catch (e) {
    console.error("Error while removing analytics cookies", e);
  }
};

export const updateGTMConsents = (categories: string[]) => {
  const dataLayer: Record<string, string> = {
    event: "update_gmt_consents",
  };

  // Handle ad_storage
  const adStorageGranted = categories.includes(COOKIE_CONSENT_CATEGORY.ADS);

  if (adStorageGranted) {
    dataLayer[COOKIE_CONSENT_CATEGORY.ADS] = CONSENT_STORAGE_STATE.GRANTED;
    dataLayer[COOKIE_CONSENT_CATEGORY.PERSONALIZATION] =
      CONSENT_STORAGE_STATE.GRANTED;
    dataLayer[COOKIE_CONSENT_CATEGORY.USER_DATA] =
      CONSENT_STORAGE_STATE.GRANTED;
  } else {
    dataLayer[COOKIE_CONSENT_CATEGORY.ADS] = CONSENT_STORAGE_STATE.DENIED;
    dataLayer[COOKIE_CONSENT_CATEGORY.PERSONALIZATION] =
      CONSENT_STORAGE_STATE.DENIED;
    dataLayer[COOKIE_CONSENT_CATEGORY.USER_DATA] = CONSENT_STORAGE_STATE.DENIED;
    removeAdCookies();
  }

  // Handle analytics_storage
  const analyticsStorageGranted = categories.includes(
    COOKIE_CONSENT_CATEGORY.ANALYTICS,
  );

  if (analyticsStorageGranted) {
    dataLayer[COOKIE_CONSENT_CATEGORY.ANALYTICS] =
      CONSENT_STORAGE_STATE.GRANTED;
  } else {
    dataLayer[COOKIE_CONSENT_CATEGORY.ANALYTICS] = CONSENT_STORAGE_STATE.DENIED;

    removeAnalyticsCookies();
  }

  TagManager.dataLayer({
    dataLayer,
  });
};

export const getConsentedCategories = () => {
  let categories: string[] = [];

  try {
    const cookie = getCookie();

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (cookie.categories && cookie.categories.length > 0) {
      categories = cookie.categories;
    }
  } catch (e) {
    console.error("Error while parsing cookieConsents cookie", e);
  }

  return categories;
};

export const hasCookiesConsent = () => {
  const categories = getConsentedCategories();

  return [COOKIE_CONSENT_CATEGORY.ADS, COOKIE_CONSENT_CATEGORY.ANALYTICS].every(
    (category) => categories.includes(category),
  );
};
